'use client';

import useCookieExpirationCheck from '@hooks/useCookieExpirationCheck';

/**
 * 쿠키 만료 체크 컴포넌트
 * layout에서 사용하여 쿠키 만료 시 로그인 페이지로 리다이렉트
 */
function CookieExpirationChecker() {
  useCookieExpirationCheck();
  return null;
}

export default CookieExpirationChecker;
